import { Directive, HostListener, ElementRef, AfterViewInit, Input, EventEmitter, Output } from '@angular/core';

@Directive({
    selector: '[payex-inifinite-scroll]'
})
export class PayexInfiniteScroll implements AfterViewInit {
    @Output() onScrollReachedEnd = new EventEmitter();
    elementRef;
    constructor(el: ElementRef) {
    }

    ngAfterViewInit() {
    }

    @HostListener('scroll', ['$event'])
    scroll(ev) {
        if ((ev.target.offsetHeight + ev.target.scrollTop + 200) >= ev.target.scrollHeight) {
            if (this.onScrollReachedEnd) {
                this.onScrollReachedEnd.emit();
            }
        }
    }
}
